module.exports = __webpack_public_path__ + "static/media/hero.94e8c5e2.png";